
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class vAutocomplete extends Vue {
  @Prop() value: any;
  @Prop() items: any;
  @Prop() displayProp: any;
  @Prop() fallbackDisplayProp: any;
  @Prop() valueProp: any;
  @Prop() bag: any;
  @Prop() placeholder!: string;
  @Prop() maxItems!: number;

  currentIndex: number = 0;

  isOpen: boolean = false;
  searchTerm: string = "";

  @Watch("value")
  valueChanged() {
    if (this.value) {
      let matchingItem = this.items.find(
        // @ts-ignore
        (x) => x[this.valueProp] === this.value
      );
      if (matchingItem) {
        this.searchTerm = matchingItem[this.displayProp];
      }
      else {
        this.searchTerm = "";
      }
    }
    else {
      if (this.fallbackDisplayProp) {
        this.searchTerm = this.fallbackDisplayProp;
      }
      else {
        this.searchTerm = "";
      }
    }
  }

  @Watch("items")
  itemsChanged() {
    this.valueChanged();
  }

  created() {
    this.valueChanged();
  }

  selectedItem() {
    // @ts-ignore
    return this.items.find((x) => x[this.valueProp] === this.value);
  }

  change() {
    if (this.isOpen == false) {
      this.isOpen = true;
      this.currentIndex = 0;
    }
  }

  up() {
    this.currentIndex--;
    if (this.currentIndex < 0) {
      this.currentIndex = 0;
    }
  }

  down() {
    this.currentIndex++;
    if (this.currentIndex > this.filteredItems.length - 1) {
      this.currentIndex = this.filteredItems.length - 1;
    }
  }

  esc() {
    this.isOpen = false;
  }

  onEnter() {
    setTimeout(() => {
      if (this.filteredItems.length > 0) {
        this.isOpen = true;
      }
    }, 550);
  }

  onLeave() {
    setTimeout(() => {
      let matchingItem = this.items.find(
        // @ts-ignore
        (x) => x[this.displayProp].toLowerCase() === this.searchTerm.toLowerCase()
      );

      if (matchingItem) {
        if (
          matchingItem[this.displayProp].toLowerCase() !==
          this.searchTerm.toLowerCase()
        ) {
          this.$emit("update:value", matchingItem[this.valueProp]);
        }
      }
      else {
        this.$emit("update:value", null);
        if (this.fallbackDisplayProp) {
          this.searchTerm = this.fallbackDisplayProp;
        }
        else {
          this.searchTerm = "";
        }
      }

      this.isOpen = false;
      //this.$emit("itemSelected", this.selectedItem(), this.bag);
    }, 500);
  }

  itemChosen() {
    if (this.filteredItems.length > 0) {
      let matchingItem = this.filteredItems[this.currentIndex];
      if (matchingItem) {
        this.searchTerm = matchingItem[this.displayProp];
        this.$emit("update:value", matchingItem[this.valueProp]);
      }
      else {
        if (this.fallbackDisplayProp) {
          this.searchTerm = this.fallbackDisplayProp;
        }
        else {
          this.searchTerm = "";
        }
        this.$emit("update:value", null);
      }
    }
    else {
      this.searchTerm = "";
      this.$emit("update:value", null);
    }

    this.$emit("itemSelected", this.selectedItem(), this.bag);
    this.isOpen = false;
  }

  itemClicked(index: number) {
    this.currentIndex = index;
    this.itemChosen();
  }

  isActive(index: number) {
    return index === this.currentIndex;
  }

  displayItem(item: any) {
    return item[this.displayProp];
  }

  get filteredItems() {
    // @ts-ignore
    let filteredItems = this.items.filter((x) => {
      return (
        x[this.displayProp]
          .toLowerCase()
          .indexOf(this.searchTerm.toLowerCase()) >= 0
      );
    });
    // @ts-ignore
    filteredItems = filteredItems.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return this.maxItems != null
      ? filteredItems.slice(0, this.maxItems)
      : filteredItems;
  }
}
